// extracted by mini-css-extract-plugin
export default {"captcha":"WEEif","captchaInput":"Qkewz","bis":"sHLow","imgBis":"renQV","resetBis":"odHaR","inputBis":"C4bYO","reset":"TQ4bL","headerCaptcha":"qDVM1","loginPage":"cGA4i"};